import { MetricField } from "../../gql-generated/types";
import { safeDivide } from "../math";
import { type InsightsMetricsMap, type StatsItem } from "../models";

const { PlayTimeMillis, LensUniques, UniqueSessions } = MetricField;

export const computeAdditionalInsightsValues = (
    metrics: InsightsMetricsMap<StatsItem>,
): {
    sessionPerUU: number;
    playTimePerSession: number;
    playTimePerUU: number;
} => {
    const playTimeValue = metrics[PlayTimeMillis]?.totalValue;
    const lensUniquesValue = metrics[LensUniques]?.totalValue;
    const uniqueSessionsValue = metrics[UniqueSessions]?.totalValue;

    const sessionPerUU = safeDivide(uniqueSessionsValue ?? 0, lensUniquesValue ?? 0);
    const playTimePerSession = safeDivide(playTimeValue ?? 0, uniqueSessionsValue ?? 0) / 1000;
    const playTimePerUU = safeDivide(playTimeValue ?? 0, lensUniquesValue ?? 0) / 1000;

    return { sessionPerUU, playTimePerSession, playTimePerUU };
};
